export default class PoziadavkaChangeStateModalCtrl{
  constructor($uibModalInstance, poziadavka){
    this.dialog = $uibModalInstance;
    this.poziadavka = poziadavka;
  }

  ok(){
    this.dialog.close(this.poziadavka);
  }

  cancel(){
    this.dialog.dismiss('cancel')
  }
}


// WEBPACK FOOTER //
// ./src/poziadavky/PoziadavkaChangeStateModalCtrl.js